import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
const angularModules = [ CommonModule, HttpClientModule];


@NgModule({
  declarations: [],
  imports: [
    ...angularModules
  ]
})
export class CoreApiModule { }
